<div class="is-flex align-center justify-center break-newline has-text-centered">
    {{ data.message }}
</div>
